module.exports = __webpack_public_path__ + "img/og-image.247c6798.jpg";